import { Component, OnInit } from '@angular/core';
import { Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent} from "@angular/router";
import {filter, switchMap, tap} from 'rxjs';
import { ProfileService } from 'src/app/auth_profile/services/profile.service';
import { NativeServiceApiProvider } from 'src/app/services/native-api-provider.service';
import { ThemeService } from 'src/app/services/theme.service';
import {LangService} from "../../services/lang.service";
import {AuthorizationServiceProvider} from "../../auth_profile/services/authorization-service.provider";

@Component({
    selector: 'app-teacher-dashboard-layout',
    templateUrl: './teacher-dashboard-layout.component.html',
    styleUrls: ['./teacher-dashboard-layout.component.scss'],
    standalone: false
})
export class TeacherDashboardLayoutComponent implements OnInit {

  activePath: string
  activeSegments: string[]
  theme: string
  profilePhoto: string
  schoolId: number
  isAppNative: boolean

  constructor(
    router: Router,
    private profileService: ProfileService,
    public themeService: ThemeService,
    public provider: NativeServiceApiProvider,
    private langService: LangService,
    private authService: AuthorizationServiceProvider
  ) {
    router.events.pipe(
      filter((e: Event): e is NavigationStart | NavigationEnd | NavigationCancel | NavigationError => e instanceof NavigationStart ||
                         e instanceof NavigationEnd ||
                         e instanceof NavigationCancel ||
                         e instanceof NavigationError)
    ).subscribe((e: RouterEvent) => {
        this.activePath = e['urlAfterRedirects']
        this.activePath? this.activeSegments = this.activePath.split('/') : ''
    });

    this.langService.initialize()
    this.loadSchoolId().subscribe()
    this.authService.getCommonRoutines().subscribe(auth =>
      this.isAppNative = auth.isNativeAuthorization()
    )
  }

  ngOnInit(): void {
    this.loadProfilePhoto()
    this.themeService.getTheme().subscribe(theme =>
      this.theme = theme)
  }

  private loadProfilePhoto() {
    this.profileService.getSelfPhoto().subscribe(photo => {
      this.profilePhoto = photo?.publicAccessUrl || null
    })
  }

  private loadSchoolId() {
    return this.authService.getAuthDetailsService().pipe(
      switchMap( api => api.getSelfSchoolId()),
      tap((id: number) => this.schoolId = id)
    )
  }
}
